import React, { FC } from 'react';
import Spinner from '../../spinner/Spinner';
import './input-with-loader.scss';
import { InputProps } from '@zooplus/ui-components';

type InputWithLoaderProps = InputProps & {
  isLoading?: boolean;
};

const InputWithLoader: FC<InputWithLoaderProps> = (props) => {
  return (
    <div className="contactForm__inputWithLoader">
      {props.isLoading && (
        <div
          className="contactForm__inputWithLoaderSpinnerWrapper"
          data-test="inputWithLoader.loading">
          <Spinner isDisabled={props.isDisabled} />
        </div>
      )}
      {props.children}
    </div>
  );
};

export default InputWithLoader;
